<template>
  <v-card class="mx-auto" color="white" :loading="loading" :disabled="loading">
    <v-toolbar color="primary">
      <v-toolbar-title>
        <h1>
          {{ $t("generate.title") }}
        </h1>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <h2 class="pb-2">
        {{ $t("generate.topic") }}
      </h2>
      <v-row>
        <v-col cols="12" md="3">
          <h3>
            {{ $t("generate.level") }}
          </h3>
          <v-autocomplete
            variant="outlined"
            density="compact"
            v-model="level_id"
            v-bind:items="levels"
            v-bind:item-value="(item) => item.level_id"
            v-bind:item-title="
              (item) =>
                inlineTranslator({
                  en: item.level_name_en,
                  th: item.level_name_th,
                })
            "
            @update:modelValue="update_level"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <h3>
            {{ $t("generate.year") }}
          </h3>
          <v-autocomplete
            variant="outlined"
            density="compact"
            v-model="year_id"
            v-bind:items="years"
            v-bind:item-value="(item) => item.YEAR_ID"
            v-bind:item-title="
              (item) => item.ADMIT_SEMESTER + '/' + item.ADMIT_YEAR
            "
            :disabled="!level_id"
            @update:modelValue="update_year"
          >
          </v-autocomplete>
        </v-col>
        <v-col>
          <v-btn
            :class="$vuetify.display.smAndUp ? 'mt-6' : 'mb-5'"
            variant="outlined"
            color="primary"
            @click="change_mode('check')"
            :disabled="!(level_id && year_id) || mode_id === 'check'"
            >ตรวจสอบรายชื่อ</v-btn
          >
        </v-col>
      </v-row>
      <!-- สิ้นสุดส่วนนำเข้าแบบกลุ่ม -->
      <v-row justify="space-around">
        <v-btn
          class="mt-3 mb-5"
          color="primary"
          @click="change_mode('real')"
          v-if="student_id_data && student_id_data.length"
          >ยืนยันการสร้างรหัสนักศึกษา</v-btn
        >
      </v-row>
    </v-card-text>

    <v-divider> </v-divider>

    <v-card-text v-if="student_id_data">
      <v-row>
        <v-col cols="12" md="12">
          <v-btn color="success" class="ml-5">
            <download-excel
              :fields="json_fields"
              :data="json_data"
              type="xlsx"
              :name="`gen-student-id-${semester}-${year}.xlsx`"
            >
              {{ $t("generate.data") }}
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
            </download-excel>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-table>
            <thead>
              <tr>
                <th>#</th>
                <th
                  v-for="(student_head, index) in student_id_head"
                  :key="index"
                >
                  {{ student_head }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, index) in student_id_data" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-for="(student_detail, index2) in student" :key="index2">
                  {{ student_detail }}
                </td>
              </tr>
            </tbody>
          </v-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { inlineTranslator } from "@/helper/translator";
import GenStudentIDProvider from "@/services/gen.student.id.provider";
import ConfigProvider from "@/services/config.provider";
import { listFilter, getById } from "@/helper/filter";

const genStudentIDProvider = new GenStudentIDProvider();
const configProvider = new ConfigProvider();

export default {
  name: "GenerateStudentID",
  data: () => ({
    loading: false,
    level_id: null,
    year_id: null,
    mode_id: null,
    years: [],
    student_id_data: null,
    year: null,
    semester: null,
    format: null,
    json_data: [],
    student_id_head: null,

    levels: [
      {
        level_id: "1",
        level_name_en: "ปริญญาตรี",
        level_name_th: "ปริญญาตรี",
      },
      {
        level_id: "2",
        level_name_en: "บัณฑิตศึกษา",
        level_name_th: "บัณฑิตศึกษา",
      },
    ],
    modes: [
      {
        mode_id: "check",
        mode_name_en: "1. Check student ID details",
        mode_name_th: "1. ตรวจสอบการสร้างรหัส",
      },
      {
        mode_id: "real",
        mode_name_en: "2. Genarate student ID",
        mode_name_th: "2. สร้างรหัสนักศึกษา",
      },
    ],
    json_fields: [],
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  methods: {
    inlineTranslator,
    listFilter,
    getById,
    //===========================================================
    async update_level(level_id) {
      this.year_id = null;
      const years = await configProvider.getYearByLevelIds(level_id);
      this.years = years;
    },

    async update_year() {
      const ref_data_year_semester = getById(
        this.years,
        this.year_id,
        "YEAR_ID"
      );
      this.year = ref_data_year_semester.ADMIT_YEAR;
      this.semester = ref_data_year_semester.ADMIT_SEMESTER;
      this.mode_id = null;
    },

    change_mode(val) {
      this.mode_id = val;
      this.confirm_gen_student_id();
    },

    async confirm_gen_student_id() {
      this.loading = true;
      let response = null;
      if (
        (this.mode_id == "real" && this.student_id_data_num) ||
        this.mode_id == "check"
      ) {
        response = await genStudentIDProvider
          .genStudentID({
            LEVEL: this.level_id,
            YEAR: this.year,
            SEMESTER: this.semester,
            MODE: this.mode_id,
            FORMAT: "json",
          })
          .catch((error) => {
            this.$toast.error(JSON.stringify(error.response.data.message));
            this.loading = false;
          });
        if (this.mode_id == "check") {
          this.student_id_head = response.header;
          this.json_fields = Object.assign({}, this.student_id_head);
          this.json_fields = Object.assign(
            {},
            ...Object.entries(this.json_fields).map(([a, b]) => ({ [b]: a }))
          );
          this.student_id_data = response.data;
          if (this.student_id_data.length) {
            this.student_id_data_num = this.student_id_data.length;
          } else {
            this.$toast.error("ไม่พบข้อมูลผู้สมัครที่รอการสร้างรหัส");
            this.student_id_data = null;
          }
          this.json_data = this.student_id_data;
        } else {
          if (response.updated == this.student_id_data_num) {
            this.$toast.success(
              "Update sucessfully " + response.updated + " คน",
              {
                duration: 0,
              }
            );
            this.student_id_data = null;
          } else {
            this.$toast.error(
              "Update เพียง " + response.updated + " คน (ไม่ครบ)"
            );
          }
        }
      } else {
        this.$toast.error("กด Mode: 1.ตรวจสอบการสร้างรหัส ก่อน");
      }
      this.loading = false;
    },

    startDownload() {
      alert("show loading");
    },
    finishDownload() {
      alert("hide loading");
    },
  },
  components: {},
  created() {},
};
</script>

<style scoped></style>
